import { AxiosResponse } from "axios";
import Customers from "~/@core/domain/model/customer/Customers";
import api from "~/services/api";

export const getAllCustomers = () => {
    return api.get<void, AxiosResponse<Customers[]>>(`/customers`);
};